const KEY = "bearcms_tenant_id" as string;

/**
 * @description get tenant form localStorage
 */
export const currentTenant = (): number => {
    return parseInt(window.localStorage.getItem(KEY) ?? '0');
};

/**
 * @description save tenant into localStorage
 * @param token: string
 */
export const setTenant = (id: number): void => {
    window.localStorage.setItem(KEY, id.toString());
};

/**
 * @description remove tenant form localStorage
 */
export const clearTenant = (): void => {
    window.localStorage.removeItem(KEY);
};

export default { currentTenant, setTenant, clearTenant };
